/**
 * msg -> string 
 * color -> string = cor do alert
 * msgColor -> string = cor do texto
 * iconName -> string = icone para colocar antes do texto
 * ignorable -> bool = setar se pode fechar
 * _requestClose -> function = função de callback ao fechar o alert
 */

import React, { useEffect, useState } from "react";

import './Alert.css'
import getImage from "../../useFull/getImage";
const Alert = props => {
    const { msg, color, msgColor, iconName, ignorable, _requestClose } = props
    const [show, setShow] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setShow(true)
        }, 100);
    }, []);

    const handleClose = () => {
        setShow(false)
        if (_requestClose) {
            setTimeout(() => {
                _requestClose()
            }, 500);
        }
    }


    return (
        <div className={`alert-container ${show && 'fade-in'}`} style={{
            ...(color ? { backgroundColor: color } : {})
        }}>
            <div className="alert-cont-msg">
                {iconName && <div className="bg-icon" style={{ backgroundImage: `url(${getImage('icons', iconName)})` }} />}
                <span style={{
                    ...(msgColor ? { color: msgColor } : {})
                }}>{msg}</span>

            </div>

            {ignorable && (
                <div className="alert-cont-icon">
                    <div className="bg-icon" onClick={handleClose} style={{ backgroundImage: `url(${getImage('icons', 'close.png')})` }}/>
                </div>
            )}
        </div>
    )
}

export default Alert